import { Link, Typography } from '@arionbanki/arionui';
import { AppContext } from 'providers/AppContext';
import { useContext } from 'react';
import type { ENVIRONMENT } from 'types';

type LinksProps = Readonly<{
	className?: string;
	links: Record<string, string | ((env: ENVIRONMENT) => string) | undefined>;
}>;

export function Links(props: LinksProps) {
	const { config, entityType, t } = useContext(AppContext);
	const { className, links } = props;
	return (
		<>
			{Object.keys(links)
				.filter(key => links[key] !== undefined)
				.map(i => (
					<Typography key={i} TagName="p">
						<Link
							className={className}
							href={href(links[i], config.APP_ENV)}
							label={t(`${i}_${entityType}`, 'finish')}
						/>
					</Typography>
				))}
		</>
	);
}

function href(x: string | ((env: ENVIRONMENT) => string) | undefined, env: ENVIRONMENT): string {
	if (!x) return '';
	return typeof x === 'function' ? x(env) : x;
}
